import { API_CONFIGURABLES } from "../../utils/apis";
import { getRegister } from "../../utils/helpers";
import { URL_CONFIGURABLES } from "../../utils/urls";

export const useConfigurablesForm = () => {
  const sections = [
    {
      title: "Configurable Details",
      fields: [
        {
          field_name: "key",
          type: "text",
          label: "Configurable Key",
          props: { required: true },
        },
        {
          field_name: "name",
          type: "text",
          label: "Configurable Name",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_CONFIGURABLES);

  return {
    sections,
    redirect,
  };
};

export function submitConfigurables(payload: any, id: string) {
  //  on update
  if (id) {
    return {
      id,
      api: API_CONFIGURABLES,
      params: { key: payload?.key, name: payload?.name },
    };
  }
  // on create
  return {
    api: API_CONFIGURABLES,
    params: payload,
  };
}
